module.exports = __webpack_public_path__ + "media/13 New Year’s Day.8d75649b.mp3";